<template>
  <div>
    <div class="comBaseInfo">
      <div class="comBaseInfo-header" style="height: 180px;;">
        <div>
          <el-upload action="/safety/file/attachment/upload_new.htm" :show-file-list="false" :multiple="false"
            :on-success="handleAvatarSuccess" :on-remove="delFile" :before-upload="beforeAvatarUpload">
            <div class="personAvatar" style="position: relative;">
              <img v-if="ruleForm.avatarurl" :src="wjSrc+ruleForm.avatarurl" class="personAvatar">
              <img v-else src="@/assets/images/notxnan.png" class="personAvatar">
              <div class="sctxhz">{{ruleForm.avatarurl?'修改':'上传'}}照片</div>
            </div>
          </el-upload>
          <div style="width: 220px;">注：上传一寸(295px*413px)或两寸(413px*626px)照片，不可超过1M</div>
        </div>
        <div class="editBtnCom" @click="disabled=false;updateuser=true" v-if="disabled">编辑信息</div>
        <div class="editBtnCom" @click="onSave" v-else>保存信息</div>

        <div class="editBtnCom green" v-if="!updateuser" @click="savePass">保存密码</div>
        <div class="editBtnCom green" @click="disabled=true;updateuser=false;" v-else>修改密码</div>
      </div>
      <div class="comBaseInfo-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm"
          style="width: 500px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;" v-if="updateuser">
          <el-form-item label="身份证号：" prop="card">
            <el-input v-model="ruleForm.card" placeholder="请输入学员身份证号" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" prop="realName">
            <el-input v-model="ruleForm.realName" placeholder="请输入学员真实姓名" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="sex">
            <el-radio-group v-model="ruleForm.sex" :disabled="disabled">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号：" prop="loginName">
            <el-input v-model="ruleForm.loginName" :disabled="disabled" placeholder="请输入学员手机号"></el-input>
          </el-form-item>
          <el-form-item label="">
            该手机号作为登录号
          </el-form-item>
          <el-form-item label="学员ID：" prop="stuid">
            <el-input v-model="ruleForm.stuid" :disabled="disabled" placeholder="请输入学员ID编号"></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="passForm" :rules="passRules" ref="passForm" label-width="120px" class="demo-ruleForm"
          style="width: 500px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;" v-else>
          <el-form-item label="姓名：">
            <el-input v-model="ruleForm.realName" placeholder="请输入学员真实姓名" disabled></el-input>
          </el-form-item>
          <el-form-item label="原密码：" prop="oldPassword">
            <el-input v-model="passForm.oldPassword" placeholder="请输入原密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPassword">
            <el-input v-model="passForm.newPassword" placeholder="请输入新密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="passwordqr">
            <el-input v-model="passForm.passwordqr" placeholder="请再次输入密码" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };

      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.passForm.newPassword !== '') {
            this.$refs.passForm.validateField('passwordqr');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passForm.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

      var $this = this;
      return {
        rules: {
          realName: [{
            required: true,
            message: '学员姓名不能为空',
            trigger: 'blur'
          }],
          loginName: [{
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          }, {
            validator: validatePhone,
            trigger: 'blur'
          }],
        },
        disabled: true,
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value
            } = node;
            var loadUrl = '/system/district/tree2.htm'
            if (value) {
              loadUrl += '?parentId=' + value;
            }
            $this.$axios.get(loadUrl).then(res => {
              var data = res.data;
              const nodes = data.map(item => ({
                value: item.id,
                label: item.text,
                leaf: !item.isParent
              }));
              resolve(nodes);
            })
          },
        },
        ruleForm: {},
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        passForm: {},
        updateuser: true,
        passRules: {
          oldPassword: [{
            required: true,
            message: '原密码不能为空',
            trigger: 'blur'
          }],
          newPassword: [{
            required: true,
            message: '新密码不能为空',
            trigger: 'blur'
          }, {
            validator: validatePass,
            trigger: 'blur'
          }],
          passwordqr: [{
            required: true,
            message: '确认密码不能为空',
            trigger: 'blur'
          }, {
            validator: validatePass2,
            trigger: 'blur'
          }],
        }
      }
    },
    methods: {
      // 保存个人信息
      onSave: function() {
        var $this = this;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$set(this.ruleForm, 'phone', this.ruleForm.loginName);
            var role = (this.currentUser.roleCodes.indexOf('COM_ADMIN_AQKT') >= 0) ? 'COM_ADMIN_AQKT' :
              'COM_USER_AQKT'
            this.$axios.post('/system/user_role/' + role + '/save.htm', this.$qs.stringify(this.ruleForm)).then(
              res => {
                var data = res.data;
                if (data.stat == '1') {
                  this.$message({
                    message: '个人信息修改成功！',
                    type: 'success'
                  });
                  this.disabled = true;
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 修改密码保存
      savePass: function() {
        var $this = this;
        this.$refs.passForm.validate((valid) => {
          if (valid) {
            delete this.passForm.passwordqr;
            this.$axios.post('/system/user/password_upd.htm?' + this.$qs.stringify(this.passForm), null, {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
            }).then(res => {
              var data = res.data;
              if (data.stat == '1') {
                this.$message({
                  message: '密码修改成功！',
                  type: 'success'
                });
                this.passForm = {};
              } else {
                this.$message.error(data.message);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getData: function(id) {
        this.$axios.get('/system/user_role/COM_USER_AQKT/load.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.ruleForm = {
              realName: data.data.realName,
              loginName: data.data.loginName,
              stuid: data.data.stuid,
              avatarurl: data.data.avatarurl,
              card: data.data.card,
              sex: data.data.sex,
              roleCode: data.data.userType,
              orgId: data.data.orgId,
              state: '1',
              orgName: data.data.orgName,
              phone: data.data.phone,
              id: data.data.id
            };
          } else {
            this.$message.error(data.message);
          }
        })
      },
      handleAvatarSuccess(res, file) {
        if (this.ruleForm.avatarurl) {
          this.delFile(this.ruleForm.avatarurl);
        }
        this.$set(this.ruleForm, 'avatarurl', res.data.filePath);
        this.onSave();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          const img = new Image()
          img.onload = function() {
            var yicun=false;
            var ercun=false;
            if(img.width<=295&&img.height<=413){
              yicun=true
            }else if(img.width<=413&&img.height<=626){
              ercun=true
            }
            const valid = yicun||ercun;
            valid ? resolve() : reject()
          }
          img.src = URL.createObjectURL(file)
        }).then(() => {
          return file
        }, () => {
          this.$message.error('上传图片需为1寸或2寸照片!')
          return Promise.reject()
          // return false
        })
        return isLt2M && isSize
      },
      delFile: function(filePath) {
        var arr = filePath.split('/');
        var arr0 = arr[arr.length - 1].split('.');
        var fileId = arr0[0]
        this.$axios.post('/file/attachment/del.htm', this.$qs.stringify({
          id: fileId
        })).then(
          res => {
            var data = res.data;
            if (data.stat == '1') {} else {}
          })
      }
    },
    created: function() {
      this.getData(this.currentUser.id)
    }
  }
</script>
<style>
  .comBaseInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comBaseInfo-header {
    height: 122px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }

  .editBtnCom {
    width: 97px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #0071ba;
    border-radius: 23px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #0071ba;
    line-height: 44px;
    margin-left: 17px;
    cursor: pointer;
  }

  .editBtnCom.green {
    border: 1px solid rgb(0, 188, 104);
    color: rgb(0, 188, 104);
  }

  .personAvatar {
    width: 100px;
    height: 140px;
    /* border-radius: 50%; */
    overflow: hidden;
  }

  .sctxhz {
    position: absolute;
    bottom: 0;
    left: 0px;
    width: 100px;
    height: 22px;
    background: rgba(0, 0, 0, 0.6);
    /* border-radius: 0 0 70px 70px; */
    color: #fff;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Personal.vue